import React, { Component } from 'react';
import { Redirect, Link } from 'react-router-dom';
import * as Util from "../common/Util";
import * as ApiConfig from '../../api-config.js';
import GoogleSignUp from './GoogleSignUp';

class Login extends Component {
    state = {
        username: "",
        password: "",
        errorMsg: "",
        showLoader: false,
        logoUrl: "",
        autoLogin: false,
        showGoogleLogin: false,
        clientId: null,
        domain: null
    };

    constructor(props) {
        super(props);
        this.handleFormSubmit = this.handleFormSubmit.bind(this);
        this.checkImage = this.checkImage.bind(this);
        this.autoLogin = this.autoLogin.bind(this);
    }

    checkImage(url, callback) {
        var timeout = 5000;
        var timedOut = false, timer;
        var img = new Image();
        img.onerror = img.onabort = function () {
            if (!timedOut) {
                clearTimeout(timer);
                callback(url, "error");
            }
        };
        img.onload = function () {
            if (!timedOut) {
                clearTimeout(timer);
                callback(url, "success");
            }
        };
        img.src = url;
        timer = setTimeout(function () {
            timedOut = true;
            callback(url, "timeout");
        }, timeout);
    }

    componentDidMount() {
        let domain = Util.getDomain();
        this.setState({ domain: domain, errorMsg: this.props.message });
        if (this.props.isLogout.msgType === 'sessexp' && this.props.isLogout.id === "logout") {
            this.props.onLogoutClick(this.props.msg('login.sessionExpiredError'), this.props.isLogout.id);
        }
        let backendHostUrl = ApiConfig.BACKEND_SERVER;
        backendHostUrl = backendHostUrl.replace("xxxxx", domain);
        this.checkImage(backendHostUrl + '/esign/' + domain + '/logo/org_logo.jpg', (url, status) => {
            if (status !== "success") {
            this.checkImage(backendHostUrl + "/img/blusynergy_logo.png", (url, status) => {
                this.setState({ logoUrl: url });
        });
        } else {
            this.setState({ logoUrl: url });
        }
    });

        fetch(ApiConfig.BACKEND_SERVER_WIHTOUT_DOMAIN + '/showGoogleLogin', {
            method: 'GET',
            mode: 'cors',
            headers: { 'content-type': 'application/json' }
        })
            .then(response => response.json())
    .then(data => {
            if (data === true) this.setState({ showGoogleLogin: true });
    })
    .catch(error => {
            console.error(error);
    });

        fetch(ApiConfig.BACKEND_SERVER_WIHTOUT_DOMAIN + '/getClientId', {
            method: 'GET',
            mode: 'cors',
            headers: { 'content-type': 'application/json' }
        })
            .then(response => {
            if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        return response.json();
    })
    .then(data => {
            if (data.clientId) {
            console.log("Client ID fetched:", data.clientId);
            this.setState({ clientId: data.clientId });
        } else {
            throw new Error('Invalid response format');
        }
    })
    .catch(error => console.error('Error fetching client ID:', error));

        this.autoLogin();
    }

    autoLogin() {
        if (this.props.isLogout.msgType === 'auto') {
            this.setState({ showLoader: true, autoLogin: true });
            fetch(this.props.api + '/login/autoLogin?id=' + this.props.isLogout.id, {
                method: "GET",
                mode: 'cors',
                headers: { 'content-type': 'application/json' }
            }).then(response => response.json())
        .then(json => {
                this.setState({ showLoader: false });
            if (json && json.isError === true) {
                this.setState({ errorMsg: this.props.msg('login.autologinfail'), autoLogin: false });
            } else {
                this.props.onSetAuthentication(json.loginResult);
            }
        }).catch(error => {
                this.setState({ showLoader: false, autoLogin: false, errorMsg: "Failed to process auto login, Please login" });
        });
            this.setState({ showLoader: false });
        }
    }

    handleFormSubmit(e) {
        this.setState({ errorMsg: "" });
        e.preventDefault();
        let body = {
            username: this.refs.username.value,
            password: this.refs.password.value
        };
        this.setState({ showLoader: true });
        fetch(this.props.api + '/login', {
            body: JSON.stringify(body),
            method: "POST",
            mode: 'cors',
            headers: { 'content-type': 'application/json' }
        }).then(response => response.json())
    .then(json => {
            if (json.timeOut === true && json.httpCode === 401 && json.isError === true) {
            this.props.onLogoutClick(json.message);
        } else {
            if (json && json.isError === true) {
                this.setState({ errorMsg: "Invalid Username or password" });
            } else {
                this.props.onSetAuthentication(json);
            }
        }
    });
        this.setState({ showLoader: false });
    }

    render() {
        let createOrgUrl = ApiConfig.FRONT_END_HOST + '/#/organization/createOrg';
        let linkHtml = 'Don’t have an account?&nbsp;&nbsp;<a href="' + createOrgUrl + '" style="text-decoration:underline;color: blue;font-weight:bold">Sign up</a>';
        if (this.state.domain) {
            return (
                <div className="middle-box text-center loginscreen animated fadeInDown">
            {
            (this.props.isLogout.msgType !== 'sessexp' || this.props.isLogout.msgType !== 'auto') ?
                (this.props.jwtToken.length > 0) ? (<Redirect to='/' />) : null
        : ''
        }
            {this.state.showLoader === true ? (<div className="loading">Loading&#8230;</div>) : ''}
            <img alt="organization logo" src={this.state.logoUrl} className="img-responsive" />
                <h3>{this.props.msg('login.welcomeTo')}</h3>
            <span style={{ "color": "red" }}>{this.state.errorMsg}</span>
                {this.state.autoLogin === true ? <span style={{ "color": "green", fontWeight: "bold", fontSize: "14px" }}>{this.props.msg('login.autoLogin')}</span> : null}
                <form className="m-t" onSubmit={this.handleFormSubmit} style={{ "marginTop": "0px" }}>
                <div className="form-group" style={{ "textAlign": "left" }}>
                <label htmlFor="username">{this.props.msg('table.th.username')}</label>
                <input type="text" className="form-control inpt"
                    placeholder="Username" required="" name="username" ref='username' />
                    </div>
                    <div className="form-group" style={{ "textAlign": "left" }}>
                <label htmlFor="username">{this.props.msg('staff.label.password')}</label>
                <input type="password" className="form-control inpt"
                    placeholder="Password" required="" name="password" ref='password' />
                    </div>
                    <button type="submit"
                    className="btn btn-primary block full-width m-b">{this.props.msg('login.button')}
                </button>
                    {this.props.msg('forgotPassword.password')}? <Link style={{ "textDecoration": "underline", "color": "blue", "fontWeight": "bold" }} to="/forgotPassword">{this.props.msg('login.forgotPassword')}</Link> to reset
                <br /><div dangerouslySetInnerHTML={{ __html: linkHtml }} />
                </form>
                    {this.state.showGoogleLogin === true && this.state.clientId && (
                    <div>
                    <p>Or</p>
                    <GoogleSignUp clientId={this.state.clientId} />
                    </div>
                    )}
                </div>
                )
            } else {
                return (
                    <div className="middle-box text-center animated fadeInDown">
                    <div>
                    <div>
                    <div>
                    <div className="col-lg-10 col-lg-offset-1">
                    <div className="ibox">
                    <div className="ibox-content">
                    {this.props.msg('login.contactSupport')}
            <p>Or</p><br />
                <div dangerouslySetInnerHTML={{ __html: linkHtml }} />
                {this.state.showGoogleLogin === true && this.state.clientId && (
                <GoogleSignUp clientId={this.state.clientId} />
                )}
            </div>
                </div>
                </div>
                </div>
                </div>
                </div>
                </div>
            )
            }
        }
    }

    export default Login;



// WEBPACK FOOTER //
// ./src/components/security/Login.js